/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import User from 'images/user.png';
import Logout from 'images/logout.png';
import AlignJustify from 'images/alignJustify.png';
import Image from 'components/UI/Drawable/Image';
import If from '../../UI/If/If';
import Button from '../../UI/Button/Button';

import './Top.css';

const ticketIconStyle = {
  fontSize: '1.25rem',
};

const actionButtonStyles = {
  cursor: 'pointer',
  marginLeft: '5px',
  marginTop: '7px',
};

function Top({
  callNext, collapse, disabledCallButton, environmentName, label, loggedOnWorkstation, login, logout,
  search, setLabel, showCallButton, userCallTicketDirectly, username, workstation
}) {
  const [showOptions, setShowOptions] = useState(false);

  return (
      <>
        <div className="topbar">
          <div className="col-2 col-sm-1 toggle-button">
            <img alt="toggle" onClick={collapse} src={AlignJustify} />
          </div>
          <div className="col-9 col-sm-3 p-0 d-flex flex-column justify-content-center workstation-info">
            <If test={loggedOnWorkstation}>
              <span>
                <span className="ml-1 title" >
                  {`${environmentName} / ${workstation.name}`}
                </span>
                <strong className="ml-1 title">{workstation.number}</strong>
              </span>
            </If>
          </div>
          <If test={userCallTicketDirectly === 'T'}>
            <div className="col-12 col-sm-3 d-flex justify-content-center call-button">
              <div className="input-group mr-sm-2">
                <div className="input-group-prepend">
                  <div className="input-group-text"><FontAwesomeIcon icon="receipt" style={ticketIconStyle} /></div>
                </div>
                <input
                  className="form-control"
                  id="ticketlabel"
                  onChange={(event) => setLabel(event.target.value)}
                  placeholder="Rótulo"
                  type="text"
                  value={label}
                />
                <div onClick={() => {search(label)}} role="presentation" style={actionButtonStyles}>
                  <FontAwesomeIcon
                    icon="redo"
                    title="Chamar senha"
                  />
                </div>
              </div>
            </div>
          </If>
          <div className="col-12 col-sm-3 d-flex justify-content-center call-button">
            <If test={showCallButton}>
              <div>
                <Button
                  className="btn-secondary"
                  disabled={disabledCallButton}
                  onClick={callNext}
                  text="Chamar próximo"
                  type="button"
                />
              </div>

            </If>
          </div>
          <div
            className="nav-item user-dropdown"
            onBlur={() => () => setShowOptions(false)}
            onClick={() => setShowOptions(true)}
            onFocus={() => 'void 0'}
            onMouseOut={() => setShowOptions(false)}
            onMouseOver={() => setShowOptions(true)}
            role="group"
          >
            <ul
              className="d-flex justify-content-center"
              style={{ marginBottom: 0, paddingLeft: 25, paddingRight: 5, cursor: 'pointer' }}
            >
              <li className="dropdown" style={{ listStyleType: 'none' }}>
                <span className="dropdown-toggle" href="#/">
                  <FontAwesomeIcon icon="user" />
                </span>

                <div className="dropdown-menu dropdown-menu-right m-0" style={{ display: showOptions ? 'block' : 'none', transition: 'all 0.3s' }}>
                  <span className="dropdown-item">
                    <Image className="mr-2" src={User} />
                    {`${username} (${login})`}
                  </span>
                  <div className="dropdown-divider" />
                  <a className="dropdown-item" href="#/" onClick={logout}>
                    <Image className="mr-2" src={Logout} />
                    Sair
                  </a>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </>
  );
}

Top.propTypes = {
  callNext: PropTypes.func.isRequired,
  collapse: PropTypes.func,
  disabledCallButton: PropTypes.bool.isRequired,
  environmentName: PropTypes.string,
  label: PropTypes.string,
  loggedOnWorkstation: PropTypes.bool,
  login: PropTypes.string,
  logout: PropTypes.func,
  search: PropTypes.func,
  setLabel: PropTypes.func,
  showCallButton: PropTypes.bool,
  userCallTicketDirectly: PropTypes.string,
  username: PropTypes.string,
  workstation: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    number: PropTypes.number
  })
};

Top.defaultProps = {
  collapse: () => {},
  environmentName: '',
  loggedOnWorkstation: false,
  login: '',
  logout: () => {},
  showCallButton: false,
  userCallTicketDirectly: 'F',
  username: '',
  workstation: {
    id: 0,
    name: '',
    number: 0
  }
};

export default Top;
